<template>
	<div class="container">
		<div class="handle-container">
			<div class="search-container">
			</div>
			<div class="btn-style">
				<Button type="primary" icon="md-add" @click="openSyncModal" style="margin-right: 10px;">同步</Button>
				<Button type="primary" icon="md-add" @click="openModal">添加意图</Button>
			</div>
		</div>
		<div class="table-container">
			<Table :columns="columns" :data="showIntents" @on-selection-change="handleSelectionChange">
				<template slot-scope="{ row, index }" slot="option">
					<span class="edit-style" @click='handleEdit(row, index)'>编辑</span>
					<Poptip confirm title="确认要删除这条数据吗？" @on-ok="delIntent(row.id)" transfer>
						<span class="del-style">删除</span>
					</Poptip>
				</template>
				<template slot-scope="{ row }" slot="sentences">
					<div class="keywordCon">
						{{row.sentences.map(item => item.replace(/;/g, '\\;')).join(';')}}
					</div>
				</template>
			</Table>
		</div>
		<div class="flex flex-justify-center">
			<Page :total="intents.length" :current.sync="page" :page-size="pageSize" show-sizer @on-page-size-change="pageSize=$event"/>
		</div>
		<intent-modal v-model="showIntentModal" :curIntent="curIntent" @onCancel="curIntent = undefined"
			@onSubmit="editIntent" />
		<sync-modal v-model="showSyncModal" @onSubmit="handleSync" />
	</div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getSceneDetailA, editSceneA, addSceneIntentA } from '@/server/api'
import cloneDeep from 'lodash/cloneDeep'
import IntentModal from './components/intentModal.vue';
import SyncModal from '@/components/SyncModal.vue';

export default {
	components: {
		IntentModal,
		SyncModal,
	},
	data() {
		return {
			showIntentModal: false,
			showSyncModal: false,
			curIntent: undefined,
			columns: [
				{
					type: 'selection',
					width: 60,
					align: 'center'
				},
				{ title: '名称', key: 'name', width: '150px' },
				{ title: '关键词', slot: 'sentences' },
				{ title: '操作', slot: 'option', width: '130px' },
			],
			pageSize: 10,
			page: 1,
			// 勾选的意向
			selectedIntents: [],
		}
	},
	computed: {
		...mapState('intents', [
			'intents'
		]),
		showIntents() {
			const startIndex = (this.page - 1) * this.pageSize;
			return this.intents?.slice(startIndex, startIndex + this.pageSize) || [];
		},
	},
	methods: {
		...mapActions('intents', ['saveIntent', 'delIntent']),
		openModal() {
			this.showIntentModal = true;
		},
		openSyncModal() {
			this.showSyncModal = true;
		},
		async handleSync(syncData, callback) {
			try {
				// 1. 根据获取的意图和同步的内容获取到要同步的数据
				const syncIntents = this.getSyncIntents(syncData);

				if (syncIntents.length === 0) {
					this.$Message.warning('没有可同步的意图数据');
					if (callback) callback();
					return;
				}

				// 2. 循环选择的话术
				const { sceneId, duplicateHandle, keywordHandle, syncContent } = syncData;
				let successCount = 0;
				let failCount = 0;

				for (const targetSceneId of sceneId) {
					try {
						// 3. 根据话术id获取到话术json
						const sceneResponse = await getSceneDetailA({ sceneId: targetSceneId });
						if (sceneResponse.code !== 200) {
							failCount++;
							continue;
						}

						const sceneJsonStr = sceneResponse.data?.sceneJson || '{}';
						const targetSceneName = sceneResponse.data?.sceneName || '';
						let sceneJson;
						try {
							sceneJson = JSON.parse(sceneJsonStr);
						} catch (error) {
							console.error('话术JSON解析失败:', error);
							failCount++;
							continue;
						}

						// 4. 根据重复处理把意图添加到话术json中
						const updatedIntents = this.mergeIntents(
							sceneJson.intents || [],
							syncIntents,
							duplicateHandle,
							keywordHandle,
							syncContent,
						);
						// 保存更新后的话术
						const saveResponse = await editSceneA({
							ver: 2,
							sceneId: targetSceneId,
							sceneJson: JSON.stringify({
								...sceneJson,
								id: targetSceneId,
								version: sceneJson.version || '2.2',
								name: targetSceneName || sceneJson.name || '',
								intents: updatedIntents
							})
						});

						if (saveResponse.code === 200) {
							successCount++;
							// 建立目标场景与意图词库的引用关系
							syncIntents.forEach(syncIntent => {
								if (syncIntent.ref_id && typeof syncIntent.ref_id === 'string') {
									addSceneIntentA({
										scene_id: targetSceneId,
										intent_id: syncIntent.ref_id,
										scene_name: targetSceneName,
									});
								}
							});
						} else {
							failCount++;
						}
					} catch (error) {
						console.error(`同步话术 ${targetSceneId} 失败:`, error);
						failCount++;
					}
				}

				if (successCount > 0) {
					this.$Message.success(`同步完成：成功 ${successCount} 个，失败 ${failCount} 个`);
				} else {
					this.$Message.error('同步失败，请重试');
				}
				callback()
			} catch (error) {
				console.error('同步过程出错:', error);
				this.$Message.error('同步失败，请重试');
				callback(error)
			}
		},
		// 根据同步内容获取要同步的意图数据
		getSyncIntents(syncData) {
			const { syncContent } = syncData;
			const currentIntents = cloneDeep(this.selectedIntents || []);

			return currentIntents.map(intent => {
				const { name, sentences, ref_id, ...otherParams } = intent;
				// 基本信息 (name)
				let syncIntent = {
					name: name,
				};

				// 关键词
				if (syncContent.includes('2')) {
					syncIntent.sentences = sentences || [];
					syncIntent.ref_id = ref_id;
					syncIntent.is_ref_priority = true;
				}

				// 其他设置 (digits)
				if (syncContent.includes('3')) {
					syncIntent = {
						...syncIntent,
						...otherParams,
						digits: intent.digits || '',
					}
				}

				return syncIntent;
			})
		},
		// 合并意图到话术JSON中
		mergeIntents(existingIntents, syncIntents, duplicateHandle, keywordHandle, syncContent) {
			const result = cloneDeep(existingIntents);
			const existingMap = new Map();
			// 建立现有意图的映射（按name）同时获取到最大的意图id
			let maxIntentId = 0;
			result.forEach(intent => {
				const idNum = parseInt(intent.id.replace('I', ''));
				if (!isNaN(idNum) && idNum > maxIntentId) {
					maxIntentId = idNum;
				}
				existingMap.set(intent.name, intent);
			});
			const getNewId = () => {
				// 递增ID并格式化为5位数字
				const nextId = ++maxIntentId;
				return `I${nextId.toString().padStart(5, '0')}`;
			}

			syncIntents.forEach(syncIntent => {
				const {sentences = [], ref_id, name, ...otherParams } = syncIntent;
				let existingIntent = existingMap.get(syncIntent.name);

				if (existingIntent) {
					// 重复处理：覆盖
					if (duplicateHandle === 'cover') {
						// 关键词处理
						if (keywordHandle === 'cover' && syncContent.includes('2')) {
							// 覆盖关键词
							existingIntent.sentences = sentences || [];
							existingIntent.ref_id = ref_id;
						} else if (keywordHandle === 'append' && syncContent.includes('2')) {
							// 补充关键词（去重）
							const existingSentences = existingIntent.sentences || [];
							existingIntent.sentences = [...new Set([...existingSentences, ...sentences])];
							existingIntent.ref_id = existingIntent.ref_id || ref_id;
						}

						// 更新其他字段
						if (syncContent.includes('1')) existingIntent.name = name;
						if (syncContent.includes('3')) {
							Object.assign(existingIntent, otherParams, { is_ref_priority: true });
						}
					}
				} else {
					// 新意图，添加到结果中
					const newIntent = {
						id: getNewId(),
						name: syncIntent.name || '',
						sentences: syncIntent.sentences || [],
						digits: syncIntent.digits || '',
						ref_id: syncIntent.ref_id || '',
						// 这个值现在只有true
						is_ref_priority: true,
					};

					result.push(newIntent);
				}
			});

			return result;
		},
		editIntent(intent) {
			this.saveIntent(intent)
		},
		handleEdit(intent, index) {
			this.curIntent = { ...intent, index };
			this.openModal();
		},
		handleSelectionChange(selection) {
			this.selectedIntents = selection;
		},
	}
}
</script>
<style lang="scss" scoped>
.container {
	width: 100%;
	padding: 20px;
	background-color: #fff;

	.handle-container {
		width: 100%;
		display: flex;
		justify-content: space-between;

		.btn-style {
			display: flex;
			justify-items: flex-start;
		}
	}

	.table-container {
		padding: 20px 0;
	}

	.del-style {
		color: #e72e2e;
		cursor: pointer;

	}

	.edit-style {
		display: inline-block;
		color: #6186cf;
		padding-right: 20px;
		cursor: pointer;
	}

	.keywordCon {
		max-height: 200px;
		overflow-y: auto;
	}
}
</style>